module.exports = __webpack_public_path__ + "media/notify.909e62d0.wav";